import {Button, Form, Space} from "antd";
import _t from "../../lang/translate";
import {OpenModalProps} from "../../types/modalTypes";
import assertFC from "../../utilities/assertFC";
import {makePurchase} from "../../services/taxDocService";
import {MakePurchaseType} from "../../types/taxDocTypes";
import TextArea from "antd/lib/input/TextArea";
import {renderErrorMessage} from "../messages/errorMessage";

export default function BuyTaxDoc<T extends object>({
  onSuccess,
  onCancel,
  payload,
}: OpenModalProps<T>) {
  const [tmpForm] = Form.useForm<MakePurchaseType>();
  const { id } = payload;

  const handleConfirm = async (values: MakePurchaseType) => {
    try {
      const { data } = await makePurchase(id, values);
      onSuccess(data as T);
    } catch (error) {
      renderErrorMessage(error)
    }
  };

  return (
    <Form
      form={tmpForm}
      requiredMark={false}
      layout="vertical"
      onFinish={handleConfirm}
    >
      <h2 className="modal-title">{_t("buy")}</h2>
      <Form.Item name="reason" label={_t("reason")}>
        <TextArea autoSize={{ minRows: 2, maxRows: 5 }} />
      </Form.Item>
      <div className="text-right">
        <Space>
          <Button type="ghost" onClick={onCancel}>
            {_t("cancel")}
          </Button>
          <Button htmlType="submit" type="primary">
            {_t("buy")}
          </Button>
        </Space>
      </div>
    </Form>
  );
}

assertFC(BuyTaxDoc);
